(function () {
  'use strict';

  function getBundlePromos(wrapper) {
    var config = wrapper.querySelector('[data-pdp-bundle-promos]');

    if (!config) {
      return [];
    }

    try {
      var promos = JSON.parse(config.textContent || '[]');
      return Array.isArray(promos) ? promos : [];
    } catch (error) {
      console.warn(
        '[PDP Add-ons] Invalid Bundle Promo configuration.',
        error
      );

      return [];
    }
  }

  function isPromoActive(promo) {
    if (!promo || promo.enabled !== true) {
      return false;
    }

    var now = Date.now();

    var start = promo.startsAt
      ? Date.parse(promo.startsAt)
      : null;

    var end = promo.endsAt
      ? Date.parse(promo.endsAt)
      : null;

    if (promo.startsAt && Number.isNaN(start)) {
      console.warn(
        '[PDP Add-ons] Invalid promo start date:',
        promo.startsAt,
        promo
      );

      return false;
    }

    if (promo.endsAt && Number.isNaN(end)) {
      console.warn(
        '[PDP Add-ons] Invalid promo end date:',
        promo.endsAt,
        promo
      );

      return false;
    }

    if (start && now < start) {
      return false;
    }

    if (end && now > end) {
      return false;
    }

    return true;
  }

  function getActivePromo(wrapper) {
    var promos = getBundlePromos(wrapper);

    var activePromos = promos.filter(function (promo) {
      return isPromoActive(promo);
    });

    if (activePromos.length > 1) {
      console.warn(
        '[PDP Add-ons] Multiple active Bundle Promos found. Using the first one.',
        activePromos
      );
    }

    return activePromos[0] || null;
  }

  function getPromoAddonInputs(wrapper, promo) {
    if (
      !promo ||
      !Array.isArray(promo.addonVariantIds)
    ) {
      return [];
    }

    return promo.addonVariantIds
      .map(function (id) {
        return wrapper.querySelector(
          '[data-pdp-addon-check][value="' +
            String(id) +
            '"]:not(:disabled)'
        );
      })
      .filter(Boolean);
  }

  function updatePromoPrice(price, promo) {
    if (
      !price ||
      price.dataset.promoPriced === 'true'
    ) {
      return;
    }

    price.dataset.promoPriced = 'true';

    var was = (price.textContent || '')
      .replace(/\.00$/, '')
      .trim();

    var freeLabel =
      promo.freeLabel &&
      String(promo.freeLabel).trim()
        ? String(promo.freeLabel).trim()
        : 'FREE';

    var wasElement = document.createElement('s');
    wasElement.className =
      'pdp-addon-products__was';
    wasElement.textContent = was;

    var freeElement =
      document.createElement('span');

    freeElement.className =
      'pdp-addon-products__free';

    freeElement.textContent = freeLabel;

    price.replaceChildren(
      wasElement,
      document.createTextNode(' '),
      freeElement
    );
  }

  function lockPromoAddons(wrapper) {
    var promo = getActivePromo(wrapper);

    if (!promo) {
      return;
    }

    var promoInputs = getPromoAddonInputs(
      wrapper,
      promo
    );

    if (!promoInputs.length) {
      console.warn(
        '[PDP Add-ons] Active promo found, but none of its gift variants exist in the product add-ons.',
        promo
      );

      return;
    }

    promoInputs.forEach(function (input) {
      input.checked = true;

      var item = input.closest(
        '.pdp-addon-products__item'
      );

      if (item) {
        item.classList.add(
          'pdp-addon-products__item--sale-locked'
        );

        item.setAttribute(
          'data-bundle-promo-name',
          promo.name || 'Bundle Promo Gift'
        );

        if (promo.discountName) {
          item.setAttribute(
            'data-bundle-promo-discount-name',
            promo.discountName
          );
        }
      }

      var price =
        item &&
        item.querySelector(
          '.pdp-addon-products__price-value, ' +
            '.pdp-addon-products__price'
        );

      updatePromoPrice(price, promo);

      input.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          input.checked = true;
        }
      );

      input.addEventListener(
        'change',
        function () {
          input.checked = true;
        }
      );
    });
  }

  function initAddonForm(wrapper) {
    if (
      wrapper.dataset.pdpAddonBound === 'true'
    ) {
      return;
    }

    wrapper.dataset.pdpAddonBound = 'true';

    lockPromoAddons(wrapper);

    var formId = wrapper.getAttribute(
      'data-product-form-id'
    );

    var form = formId
      ? document.getElementById(formId)
      : null;

    if (!form) {
      var container = wrapper.closest(
        'product-info, main, body'
      );

      if (container) {
        form = container.querySelector(
          'form[data-type="add-to-cart-form"]'
        );
      }
    }

    if (!form) {
      console.warn(
        '[PDP Add-ons] Product form not found.',
        wrapper
      );

      return;
    }

    var productForm = form.closest(
      'product-form'
    );

    form.addEventListener(
      'submit',
      function (evt) {
        var checkedInputs =
          wrapper.querySelectorAll(
            '[data-pdp-addon-check]:checked:not(:disabled)'
          );

        if (checkedInputs.length === 0) {
          return;
        }

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var formData = new FormData(form);

        var mainId = formData.get('id');

        if (!mainId) {
          console.warn(
            '[PDP Add-ons] Main product variant ID not found.'
          );

          return;
        }

        var mainQty = parseInt(
          formData.get('quantity'),
          10
        );

        if (!mainQty || mainQty < 1) {
          mainQty = 1;
        }

        var items = [
          {
            id: parseInt(mainId, 10),
            quantity: mainQty,
          },
        ];

        checkedInputs.forEach(function (input) {
          var promoItem = input.closest(
            '.pdp-addon-products__item--sale-locked'
          );

          if (promoItem) {
            return;
          }

          var variantId = parseInt(
            input.value,
            10
          );

          if (!variantId) {
            return;
          }

          items.push({
            id: variantId,
            quantity: 1,
          });
        });

        var submitBtn =
          form.querySelector(
            '[type="submit"]'
          );

        var spinner =
          form.querySelector(
            '.loading__spinner'
          );

        var cart =
          document.querySelector(
            'cart-notification'
          ) ||
          document.querySelector(
            'cart-drawer'
          );

        if (submitBtn) {
          submitBtn.setAttribute(
            'aria-disabled',
            'true'
          );

          submitBtn.classList.add(
            'loading'
          );
        }

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }

        if (
          productForm &&
          typeof productForm.handleErrorMessage ===
            'function'
        ) {
          productForm.handleErrorMessage();
        }

        var body = {
          items: items,
        };

        var sections = [];

        if (
          cart &&
          typeof cart.getSectionsToRender ===
            'function'
        ) {
          sections = cart
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            });
        }

        if (sections.length) {
          body.sections =
            sections.join(',');

          body.sections_url =
            window.location.pathname;
        }

        if (
          cart &&
          typeof cart.setActiveElement ===
            'function'
        ) {
          cart.setActiveElement(
            document.activeElement
          );
        }

        fetch(
          (window.routes &&
            window.routes.cart_add_url) ||
            '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/javascript',

              'X-Requested-With':
                'XMLHttpRequest',
            },

            body: JSON.stringify(body),
          }
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              if (
                typeof publish ===
                  'function' &&
                typeof PUB_SUB_EVENTS !==
                  'undefined'
              ) {
                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source:
                      'product-form',

                    productVariantId:
                      mainId,

                    errors:
                      response.errors ||
                      response.description,

                    message:
                      response.message,
                  }
                );
              }

              if (
                productForm &&
                typeof productForm.handleErrorMessage ===
                  'function'
              ) {
                productForm.handleErrorMessage(
                  response.description ||
                    response.message
                );
              }

              return;
            }

            if (!cart) {
              window.location =
                (window.routes &&
                  window.routes.cart_url) ||
                '/cart';

              return;
            }

            if (
              typeof publish ===
                'function' &&
              typeof PUB_SUB_EVENTS !==
                'undefined'
            ) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source:
                    'product-form',

                  productVariantId:
                    mainId,

                  cartData:
                    response,
                }
              );
            }

            if (
              typeof cart.renderContents ===
                'function'
            ) {
              cart.renderContents(
                response
              );
            }

            wrapper
              .querySelectorAll(
                '[data-pdp-addon-check]:checked'
              )
              .forEach(function (input) {
                if (
                  !input.closest(
                    '.pdp-addon-products__item--sale-locked'
                  )
                ) {
                  input.checked = false;
                }
              });
          })
          .catch(function (error) {
            console.error(
              '[PDP Add-ons] Add to cart failed.',
              error
            );
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove(
                'loading'
              );

              submitBtn.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }

            if (
              cart &&
              cart.classList.contains(
                'is-empty'
              )
            ) {
              cart.classList.remove(
                'is-empty'
              );
            }
          });
      },
      true
    );
  }

  function init() {
    document
      .querySelectorAll(
        '[data-pdp-addon-products]'
      )
      .forEach(initAddonForm);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();